import ProfileLayout from '../modules/Profile/ProfileLayout';
import PersonalInfo from '../modules/Profile/PersonalInfo';
import { CustomNextPage } from '../lib/types';
import { PROFILE_PAGE_QUERY } from '../modules/Profile/graphql';
import { profilePageQuery } from '../core-types';
import { bootstrap } from '../lib/bootstrap';

const PersonalInfoPage: CustomNextPage<{
  statusCode?: number;
}> = props => {
  const { url, statusCode } = props;
  return (
    <ProfileLayout statusCode={statusCode} url={url}>
      {({ currentUser, system }) => {
        if (!system || !currentUser) {
          return null;
        }
        return <PersonalInfo currentUser={currentUser} />;
      }}
    </ProfileLayout>
  );
};

PersonalInfoPage.getInitialProps = async ctx => {
  const profilePageQueryResult = await ctx.apolloClient.query<profilePageQuery>(
    {
      query: PROFILE_PAGE_QUERY
    }
  );
  let statusCode;
  if (
    !profilePageQueryResult.data ||
    !profilePageQueryResult.data.profilePage
  ) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  return {
    statusCode
  };
};

export default bootstrap(PersonalInfoPage);
